var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card cursor-pointer",style:({backgroundColor: _vm.color}),on:{"click":function($event){return _vm.$emit('select')}}},[_c('p',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"card__value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }